import { useEffect, useRef, useState } from 'react';

/**
 * The rendered width of an element, kept current as it resizes.
 *
 * For charts that draw in real pixels rather than a scaled viewBox: scaling a fixed
 * drawing shrinks its text with the container, so a label legible at 1,000px is 6px
 * on a phone. Measuring the container lets the drawing keep a constant type size.
 *
 * @returns [ref, width] — attach ref to the element; width is 0 until first measured.
 */
export default function useElementWidth(fallback = 0) {
  const ref = useRef(null);
  const [width, setWidth] = useState(fallback);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => setWidth(Math.round(el.getBoundingClientRect().width));
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, width];
}
